import ImageWithFallback from 'components/ImageWithFallback';
import { referralsFolder } from 'constants/Referrals';
import styles from './FriendsInvitedProgress.module.css';

interface FriendsInvitedProgressProps {
  invitedCount: number;
  totalAllowed?: number;
}

export const ReferralInviteProgressBar = ({
  invitedCount,
  totalAllowed = 3,
}: FriendsInvitedProgressProps) => {
  const safeTotalAllowed = Math.max(totalAllowed, 1);
  const safeInvitedCount = Math.min(
    Math.max(invitedCount, 0),
    safeTotalAllowed,
  );

  return (
    <div className={styles.progressBarSection}>
      {Array.from({ length: safeTotalAllowed }, (_, index) => {
        const isFilled = index < safeInvitedCount;
        const isFirstSlot = index === 0;
        const progressAsset = isFirstSlot
          ? isFilled
            ? 'progress-full-first.svg'
            : 'progress-empty-first.svg'
          : isFilled
            ? 'progress-full.svg'
            : 'progress-empty.svg';

        return (
          <div key={index} className={styles.progressBar}>
            <ImageWithFallback
              layout="fill"
              objectFit="contain"
              objectPosition="center"
              src={`${referralsFolder}/${progressAsset}`}
            />
          </div>
        );
      })}
    </div>
  );
};
